import {action} from 'typesafe-actions';

export enum AssetStatsActionTypes {
  ADD_PROCESSED = 'ADD_PROCESSED',
  ADD_AI_PROCESSED = 'ADD_AI_PROCESSED',
  SET_PROCESSED = 'SET_PROCESSED',
  SET_AI_PROCESSED = 'SET_AI_PROCESSED',
  SET_TOTAL = 'SET_TOTAL',
  SET_TOTAL_PERCENTAGE = 'SET_TOTAL_PERCENTAGE',
  SET_AI_PERCENTAGE = 'SET_AI_PERCENTAGE',
  SET_HIRES_PERCENTAGE = 'SET_HIRES_PERCENTAGE',
}

export const AssetStatsActions = {
  setProcessed: (processed: number[]) => action(AssetStatsActionTypes.SET_PROCESSED, processed),
  setAIProcessed: (processed: number[]) =>
    action(AssetStatsActionTypes.SET_AI_PROCESSED, processed),
  addProcessed: (processed: number | number[]) =>
    action(AssetStatsActionTypes.ADD_PROCESSED, processed),
  addAIProcessed: (processed: number | number[]) =>
    action(AssetStatsActionTypes.ADD_AI_PROCESSED, processed),
  setTotal: (total: number) => action(AssetStatsActionTypes.SET_TOTAL, total),
  setTotalPercentage: (total: number) => action(AssetStatsActionTypes.SET_TOTAL_PERCENTAGE, total),
  setAIPercentage: (total: number) => action(AssetStatsActionTypes.SET_AI_PERCENTAGE, total),
  setHiresPercentage: (total: number) => action(AssetStatsActionTypes.SET_HIRES_PERCENTAGE, total),
};
